<div class="curva-abc-venda-perspectiva-content">
    <div class="curva-abc-venda-perspectiva-content-header" *ngIf="config?.isShowHeader">
        
        <!-- Segmento de Itens -->
         <ng-template [ngIf]="config?.isPerspectivaSegmentoItem">
            <div class="row">
                <div class="col-12">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                Tipo
                            </span>
                        </div>
                        <div class="input-group-select">
                            <sgt-tipo-classificacao-select
                                [(ngModel)]="filter.idTipoClassificacaoItem"
                                (ngModelChange)="onChangeIdTipoClassificacao()"
                                name="curvaAbcVendaTipoClassificaoItem"
                                id="curvaAbcVendaTipoClassificaoItem"
                                [cadastroCliente]="false"
                                [canSelectNull]="false"
                                [groupByCadastro]="false"
                                [selectFirstAfterSearch]="true">
                            </sgt-tipo-classificacao-select>
                        </div>
                    </div>
                </div>
            </div>
         </ng-template>

        <!-- Segmento de Clientes -->
        <ng-template [ngIf]="config?.isPerspectivaSegmentoCliente">
            <div class="row">
                <div class="col-12">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                Tipo
                            </span>
                        </div>
                        <div class="input-group-select">
                            <sgt-tipo-classificacao-select
                                [(ngModel)]="filter.idTipoClassificacaoCliente"
                                (ngModelChange)="onChangeIdTipoClassificacao()"
                                name="curvaAbcVendaTipoClassificaoCliente"
                                id="curvaAbcVendaTipoClassificaoCliente"
                                [cadastroItem]="false"
                                [canSelectNull]="false"
                                [groupByCadastro]="false"
                                [selectFirstAfterSearch]="true">
                            </sgt-tipo-classificacao-select>
                        </div>
                    </div>
                </div>
            </div>
         </ng-template>         
    </div>
    <div class="curva-abc-venda-perspectiva-content-body">
        <sgt-curva-abc-venda-table
            #table
            [perspectiva]="perspectiva"
            [curvaAbcVenda]="curvaAbcVenda"
            [isShowCodigoIntegracaoErp]="perspectiva?.isShowCodigoIntegracaoErp">
        </sgt-curva-abc-venda-table>
    </div>        
</div>
